import script from "./VVVTutorialsNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVTutorialsNew.vue?vue&type=script&setup=true&lang=js"

import "./VVVTutorialsNew.vue?vue&type=style&index=0&id=72e8452f&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e8452f"]])

export default __exports__